/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const EditIcon: React.SFC = () => {
    return (
        <svg width="33" height="20" viewBox="0 0 33 20" xmlns="http://www.w3.org/2000/svg">
            <g fill="#CFD8DD" fillRule="evenodd">
                <path d="M18.638 3.238l4.747 4.746-9.93 9.93-4.748-4.745M22.44 1.926l2.28 2.277c.39.39.39 1.024 0 1.414l-.876.875-3.692-3.69.875-.876c.39-.39 1.024-.39 1.414 0zM8 14.425l4.475 4.475H8" />
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Edit/Edit.tsx